import React, { useState } from "react";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
// import { Link } from "react-router-dom";
import logo from "./imgs/Logo.png";
import { Link } from "react-scroll";

import type { MenuProps } from "antd";
import { Dropdown, Space, Menu } from "antd";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [menuOpen, setAboutUsMenuOpen] = useState(false);
  const openAboutUsMenu = () => {
    setAboutUsMenuOpen(true);
  };
  const closeAboutUsMenu = () => {
    setAboutUsMenuOpen(false);
  };

  // Drop down menu

  // for scrolling
  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Change this to the offset you want
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  //about us
  const aboutus: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <a onClick={() => scrollToElement("companyHistory")}>Company History</a>
      ),
    },
    {
      key: "2",
      label: (
        // <a
        //   target="_blank"
        //   rel="noopener noreferrer"
        //   href="https://www.aliyun.com"
        // >
        //   Mission & Vision
        // </a>
        <a onClick={() => scrollToElement("MissionAndVision")}>
          Mission & Vision
        </a>
      ),
    },
    {
      key: "3",
      label: (
        // <a
        //   target="_blank"
        //   rel="noopener noreferrer"
        //   href="https://www.luohanacademy.com"
        // >
        //   Team
        // </a>
        <a onClick={() => scrollToElement("Team")}>Team</a>
      ),
    },
  ];

  const OurImpact: MenuProps["items"] = [
    {
      key: "1",
      label: (
        // <a
        //   target="_blank"
        //   rel="noopener noreferrer"
        //   href="https://www.antgroup.com"
        // >
        //   Testimonials and Case Studies
        // </a>
        <a onClick={() => scrollToElement("TestimonialsAndCaseStudies")}>
          Testimonials and Case Studies
        </a>
      ),
    },
    {
      key: "2",
      label: (
        // <a
        //   target="_blank"
        //   rel="noopener noreferrer"
        //   href="https://www.aliyun.com"
        // >
        //   Awards & Recognition
        // </a>
        <a onClick={() => scrollToElement("AwardsAndRecognition")}>
          Awards & Recognition
        </a>
      ),
    },
  ];

  const MediaResources: MenuProps["items"] = [
    {
      key: "1",
      label: (
        // <a
        //   target="_blank"
        //   rel="noopener noreferrer"
        //   href="https://www.antgroup.com"
        // >
        //   Visual Gallery
        // </a>
        <a onClick={() => scrollToElement("VisualGallery")}>Visual Gallery</a>
      ),
    },
    {
      key: "2",
      label: (
        // <a
        //   target="_blank"
        //   rel="noopener noreferrer"
        //   href="/GrandShopRwandablog"
        // >
        //   Articles & Blogs
        // </a>
        <a href="/GrandShopRwandablog" target="_blank">Articles & Blogs</a>
      ),
    },
    {
      key: "3",
      label: (
        // <a
        //   target="_blank"
        //   rel="noopener noreferrer"
        //   href="https://www.luohanacademy.com"
        // >
        //   FAQs
        // </a>
        <a onClick={() => scrollToElement("FAQs")}>FAQs</a>
      ),
    },
  ];

  return (
    <header className="bg-white text-black pt-8 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-textColor">
              <img
                className="w-24 h-auto"
                src={logo}
                alt="Grand Shop Rwanda Logo"
              />
            </Link>
          </div>

          {/* Social Media Icons */}
          <div className="hidden md:flex space-x-4">
            <a href="#" className="text-textColor hover:text-customBlue">
              <FaFacebookF size={20} />
            </a>
            <a href="#" className="text-textColor hover:text-customBlue">
              <FaTwitter size={20} />
            </a>
            <a href="#" className="text-textColor hover:text-customBlue">
              <FaInstagram size={20} />
            </a>
          </div>

          {/* Navigation Links */}
          <nav className="hidden md:flex space-x-8">
            {/* Add Home Link here */}
            {/* <Link
              to="/" // Directs to the root route
              className="cursor-pointer text-textColor hover:text-customBlue"
              onClick={() => Home()}
            >
              Home
              </Link> */}
            <a href="/">Home</a>

            <div>
              <Space direction="vertical">
                <Space wrap>
                  {/* Correct usage of the `menu` prop */}
                  <Dropdown menu={{ items: aboutus }} placement="bottom" arrow>
                    <Link
                      to="#"
                      smooth={true}
                      duration={500}
                      className="cursor-pointer text-textColor hover:text-customBlue"
                      onMouseEnter={openAboutUsMenu}
                      onMouseLeave={closeAboutUsMenu}
                    >
                      About Us
                    </Link>
                  </Dropdown>
                </Space>
              </Space>
            </div>

            <div>
              <Space direction="vertical">
                <Space wrap>
                  <Dropdown
                    menu={{ items: OurImpact }}
                    placement="bottom"
                    arrow
                  >
                    <Link
                      to="aboutus"
                      smooth={true}
                      duration={500}
                      className="cursor-pointer text-textColor hover:text-customBlue"
                      onMouseEnter={openAboutUsMenu}
                      onMouseLeave={closeAboutUsMenu}
                    >
                      Our Impact
                    </Link>
                  </Dropdown>
                </Space>
              </Space>
            </div>
            <div>
              <Space direction="vertical">
                <Space wrap>
                  <Dropdown
                    menu={{ items: MediaResources }}
                    placement="bottom"
                    arrow
                  >
                    <Link
                      to="aboutus"
                      smooth={true}
                      duration={500}
                      className="cursor-pointer text-textColor hover:text-customBlue"
                      onMouseEnter={openAboutUsMenu}
                      onMouseLeave={closeAboutUsMenu}
                    >
                      Media & Resources
                    </Link>
                  </Dropdown>
                </Space>
              </Space>
            </div>
            <div>
              <Space direction="vertical">
                <Space wrap>
                  {/* <Link
                    to="aboutus"
                    smooth={true}
                    duration={500}
                    className="cursor-pointer text-textColor hover:text-customBlue"
                    onMouseEnter={openAboutUsMenu}
                    onMouseLeave={closeAboutUsMenu}
                  >
                    Get In Touch
                  </Link> */}
                  <a
                    className="text-textColor hover:text-[#3A636C]"
                    onClick={() => scrollToElement("GetInTouch")}
                  >
                    Get In Touch
                  </a>
                </Space>
              </Space>
            </div>
          </nav>

          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-black focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="bg-customBlue md:hidden fixed inset-0 bg-bg py-0">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0">
              <Link to="/" className="text-2xl font-bold text-hovered">
                <img className="w-24 h-auto" src={logo} alt="Honex Logo" />
              </Link>
            </div>

            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-black focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          <nav className="flex flex-col justify-center items-center text-center gap-8 h-screen text-xl">
            {/* Mobile Links */}
            <Link
              to="/" // Add Home link for mobile
              className="cursor-pointer text-textColor hover:text-customBlue"
            >
              Home
            </Link>
            <Link
              to="aboutus"
              className="cursor-pointer text-textColor hover:text-customBlue"
            >
              About Us
            </Link>
            <Link
              to="aboutus"
              className="cursor-pointer text-textColor hover:text-customBlue"
            >
              Our Impact
            </Link>
            <Link
              to="aboutus"
              className="cursor-pointer text-textColor hover:text-customBlue"
            >
              Media & Resources
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
